import translate from '../../translations'

export default data => {
  const str = `
    <div class="card card--edit-orga flex grey-border-bottom" data-id="0" js-card-edit-orga>
                    <div class="flex page-member-form--right-side--organisation-chart--left-side">
                      <div class="member">
                        <div class="icon-member" id="icon-member-0">

                          <svg width="42px" height="42px" class="icon icon--grey-dark" aria-hidden="true">
                            <use href="#icon-user" xlink:href="#icon-user" />
                          </svg>

                        </div>
                        <div class="card--edit-orga__pict-upload" js-file-upload="{maxSize: 1024, previewElt: 'icon-member-0'}">
                          <input class="file" type="file" id="icon-member-file-0" name="" value="" accept="image/png, image/jpeg, image/jpg, image/gif">
                          <label class="link" for="icon-member-file-0">${translate(
    'UPDATE'
  )}</label>
                        </div>
                      </div>
                      <div class="name-member">
                        <input type="text" data-name="firstName" name="member[${
  data.id
}][firstname]" value="" placeholder="${translate(
  'FIRSTNAME'
)}" class="uppon-title">
                        <input type="text" data-name="lastname" name="member[${
  data.id
}][lastname]" name="lastname" value="" placeholder="${translate(
  'LASTNAME'
)}" class="uppon-title">
                        <input type="text" data-name="function" name="member[${
  data.id
}][function]" name="function" value="" placeholder="${translate(
  'STATUS'
)}" class="gen-text--M">
                        <input type="text" data-name="functionEn" name="member[${
  data.id
}][functionEn]" name="functionEN" value="" placeholder="${translate(
  'STATUS_EN'
)}" class="gen-text--M">
                        <input type="hidden" data-name="id" value="${data.id}">
                        <input type="hidden" name="member[${
  data.id
}][position]" value="${data.position}">
                      </div>
                    </div>
                    <div class="flex page-member-form--right-side--organisation-chart--right-side">
                      <div class="flex flex-col crud">
                        <div class="link hidden" js-card-update>
                          <svg class="icon icon--red" aria-hidden="true">
                              <use href="#icon-edit" xlink:href="#icon-edit"></use>
                          </svg>
                          <span>${translate('EDIT')}</span>             
                        </div>
                        <div class="link create" js-card-confirm>
                            <svg class="icon icon--green" aria-hidden="true">
                                <use href="#icon-check" xlink:href="#icon-check"></use>
                            </svg>
                            <span>${translate(
    'VALIDATE'
  )}</span>                    
                        </div>
                        <div class="link mt-2" js-card-delete>
                          <svg class="icon icon--red" aria-hidden="true">
                              <use href="#icon-close" xlink:href="#icon-close"></use>
                          </svg>
                          <span>${translate('DELETE')}</span> 
                        </div>
                      </div>
                      <div class="flex flex-col browse">
                        <div class="browse-up" js-bt-position="up">
                          <svg class="icon icon--grey-darker" width="16px" height="16px" aria-hidden="true">
                              <use href="#icon-arrow-down" xlink:href="#icon-arrow-down" />
                          </svg>
                        </div>
                        <div class="browse-down" js-bt-position="down">
                          <svg class="icon icon--grey-darker" width="16px" height="16px" aria-hidden="true">
                              <use href="#icon-arrow-down" xlink:href="#icon-arrow-down" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>`

  return str
}
